import React from 'react'

const Toolbar = ({ 
  onFormat, 
  onMinify, 
  onValidate, 
  onDownload, 
  onCopy, 
  onClear, 
  onToggleTheme, 
  isDarkMode, 
  isValid, 
  hasContent 
}) => {
  const handleFormat = () => {
    try {
      onFormat()
      console.log('JSON formatted successfully')
    } catch (error) {
      console.error('Failed to format JSON:', error)
    }
  }

  const handleMinify = () => {
    try {
      onMinify()
      console.log('JSON minified successfully')
    } catch (error) {
      console.error('Failed to minify JSON:', error)
    }
  }

  const handleValidate = () => {
    try {
      onValidate()
      if (isValid) {
        console.log('JSON is valid')
      } else {
        console.log('JSON validation failed')
      }
    } catch (error) {
      console.error('Validation error:', error)
    }
  }

  const handleDownload = () => {
    try {
      onDownload()
      console.log('JSON downloaded successfully')
    } catch (error) {
      console.error('Failed to download JSON:', error)
    }
  }

  const handleCopy = async () => {
    try {
      await onCopy()
      console.log('JSON copied to clipboard')
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
    }
  }

  const handleClear = () => {
    onClear()
    console.log('Cleared all content')
  }

  return (
    <div className="toolbar">
      <div className="btn-group">
        <button
          className="btn btn-secondary"
          onClick={handleFormat}
          disabled={!hasContent || !isValid}
          title="Format JSON with proper indentation"
        >
          Format
        </button>
        
        <button
          className="btn btn-secondary"
          onClick={handleMinify}
          disabled={!hasContent || !isValid}
          title="Minify JSON (remove whitespace)"
        >
          Minify
        </button>
        
        <button
          className="btn btn-secondary"
          onClick={handleValidate}
          disabled={!hasContent}
          title="Validate JSON syntax"
        >
          Validate
        </button>
      </div>

      <div className="btn-group">
        <button
          className="btn btn-success"
          onClick={handleDownload}
          disabled={!hasContent || !isValid}
          title="Download JSON file"
        >
          Download
        </button>
        
        <button
          className="btn btn-success"
          onClick={handleCopy}
          disabled={!hasContent || !isValid}
          title="Copy JSON to clipboard"
        >
          Copy
        </button>
      </div>

      <div className="btn-group">
        <button
          className="btn btn-warning"
          onClick={handleClear}
          disabled={!hasContent}
          title="Clear all content"
        >
          Clear
        </button>
        
        <button
          className="btn btn-secondary"
          onClick={onToggleTheme}
          title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        >
          {isDarkMode ? 'Light' : 'Dark'}
        </button>
      </div>
    </div>
  )
}

export default Toolbar
